// Reusable debounce utility — add once at the top of custom.js:
function debounce(fn, delay = 150) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}


/* Tab Start */
function InitTabs() {
  document.querySelectorAll(".Tabs_common_main_new").forEach(container => {

        const tabs = container.querySelectorAll(".Tabs_common_inner_new");
        const contents = container.querySelectorAll(".tabcontent");

        const group = container.querySelector("[data-tab-group]");
        const bg = group ? group.querySelector(".tab_background_new") : null;

        function moveBgToTab(tab) {
            if (!group || !bg) return;

            const tabsArr = Array.from(tabs);
            const isLast = tab === tabsArr[tabsArr.length - 1];

            const tabRect = tab.getBoundingClientRect();
            const groupRect = group.getBoundingClientRect();

            let offset = tabRect.left - groupRect.left;

            // 3px gap on last tab
            if (isLast) offset -= 0;

            bg.style.width = `${tabRect.width}px`;
            bg.style.transform = `translateX(${offset}px)`;
        }

        function activateTab(tab) {
          const tabId = tab.getAttribute("tab_id");
          if (!tabId) return;

          tabs.forEach(t => t.classList.remove("active"));
          contents.forEach(c => c.style.display = "none");
          contents.forEach(c => c.classList.remove("active"));

          tab.classList.add("active");

          const targets = container.querySelectorAll(`.${tabId}_open`);
          targets.forEach(t => t.style.display = "block");
          targets.forEach(t => t.classList.add("active"));

          moveBgToTab(tab);
        }

        // 🔥 Recalculate background position on screen resize
        function updateActiveTabBg() {
            const activeTab = container.querySelector(".Tabs_common_inner_new.active");
            if (activeTab) moveBgToTab(activeTab);
        }
        window.addEventListener("resize", debounce(updateActiveTabBg, 150));

        tabs.forEach(tab => {
            tab.addEventListener("click", () => activateTab(tab));
        });

        const firstActive = container.querySelector(".Tabs_common_inner_new.active") || tabs[0];
        if (firstActive) activateTab(firstActive);

        const navMenu = document.querySelector(".menu-list__list-item");

        if(navMenu){
          navMenu.addEventListener("mouseenter", () => {
              const firstActive = container.querySelector(".Tabs_common_inner_new.active") || tabs[0];
              if (firstActive) activateTab(firstActive);
          });
        }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  InitTabs();
});
document.addEventListener("shopify:section:load", () => {
  InitTabs();
});
/* Tab End */

/* Accordian Start */
function initCustomAccordion(root) {
    const scope = root || document;
    scope.querySelectorAll(".accordion").forEach(acc => {
        const items = acc.querySelectorAll("li");

        items.forEach(item => {
            if (item.dataset.accordionBound === "true") return;
            item.dataset.accordionBound = "true";

            const question = item.querySelector(".question");
            const answer = item.querySelector(".answer");

            if (!question || !answer) return;

            // Ensure correct default state
            if (item.classList.contains("open")) {
                answer.style.display = "block";
                answer.style.height = "auto";
            } else {
                answer.style.display = "none";
                answer.style.height = 0;
            }

            question.addEventListener("click", () => {
                const isOpen = item.classList.contains("open");

                // Close all other items
                items.forEach(i => {
                    if (i === item) return;
                    i.classList.remove("open");
                    const a = i.querySelector(".answer");
                    if (a) {
                        a.style.height = a.scrollHeight + "px"; // ensure correct closing start
                        requestAnimationFrame(() => {
                            a.style.transition = "height 300ms ease";
                            a.style.height = "0px";
                        });
                        setTimeout(() => {
                            a.style.display = "none";
                            a.style.removeProperty("transition");
                        }, 300);
                    }
                });

                // If the clicked one was open, just close it
                if (isOpen) {
                    item.classList.remove("open");
                    answer.style.height = answer.scrollHeight + "px";
                    requestAnimationFrame(() => {
                        answer.style.transition = "height 300ms ease";
                        answer.style.height = "0px";
                    });
                    setTimeout(() => {
                        answer.style.display = "none";
                        answer.style.removeProperty("transition");
                    }, 300);
                    return;
                }

                // Otherwise, open it
                item.classList.add("open");
                answer.style.display = "block";
                answer.style.height = "auto";              // get natural height
                const endHeight = answer.scrollHeight + "px";
                answer.style.height = "0px";               // restart animation
                requestAnimationFrame(() => {
                    answer.style.transition = "height 300ms ease";
                    answer.style.height = endHeight;
                });
                // Wait until animation finishes, then scroll
                setTimeout(() => {
                    answer.style.height = "auto";
                    answer.style.removeProperty("transition");

                    // ✅ Scroll ONLY if inside Product_meta_collapsible_main_new
                    const container = item.closest(".Product_meta_collapsible_main_new");
                    if (container) {
                      // Scroll to question AFTER opening
                      const offset = 100; // adjust to your header height
                      const y = question.getBoundingClientRect().top + window.pageYOffset - offset;

                      window.scrollTo({
                          top: y,
                          behavior: "smooth"
                      });
                    }
                }, 300)
            });
        });
    });
}

window.initCustomAccordion = initCustomAccordion;
initCustomAccordion(document);
/* Accordian End */

/* Mobile Header Start */
function mobileMenuHeight() {
  // Get announcement bar height (with margin)
  const announcementBar = document.querySelector(".Announcement_main_new");
  const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

  // Fixed header height
  const headerEl = document.querySelector('.header-section');
  const headerHeight = headerEl ? headerEl.offsetHeight : 56;  // 56 as fallback
  const totalHeight = announcementBarHeight + headerHeight;

  // Update drawer positions
  const menuDrawer = document.querySelector(".menu-drawer");
  const menuBackdrop = document.querySelector(".menu-drawer__backdrop");

  if (menuDrawer) {
    menuDrawer.style.top = totalHeight + "px";
    menuDrawer.style.height = `calc(100% - ${totalHeight}px)`;
  }
  if (menuBackdrop) {
    //menuBackdrop.style.top = totalHeight + "px";
    menuBackdrop.style.top = "0px";
  }

  // For elements with [data-scroll-direction="up"]
  const upElements = document.querySelectorAll("[data-scroll-direction='up'], [data-scroll-direction='down']");
  const totalHeightUp = headerHeight - 1;

  upElements.forEach(el => {
    const upMenu = el.querySelector(".menu-drawer");
    const upBackdrop = el.querySelector(".menu-drawer__backdrop");

    if (upMenu) {
      upMenu.style.top = totalHeightUp + "px";
      upMenu.style.height = `calc(100% - ${totalHeightUp}px)`;
    }
    if (upBackdrop) {
      //upBackdrop.style.top = totalHeightUp + "px";
      upBackdrop.style.top = "0px";
    }
  });
}

// Initial run
mobileMenuHeight();

// Recalculate on menu button click
const menuBtn = document.querySelector(".header__icon--menu");
if (menuBtn) {
  menuBtn.addEventListener("click", mobileMenuHeight);
}

// Recalculate on window resize
window.addEventListener('resize', debounce(mobileMenuHeight, 150));
/* Mobile Header End */

/* Video Lazy Load */
document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".lazy-video");
  const isMobile = () => window.innerWidth <= 750;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      const shouldLoad =
        (video.classList.contains("Mobile_video_new") && isMobile()) ||
        (video.classList.contains("Desktop_video_new") && !isMobile());

      if (!shouldLoad) return;

      // 🔹 PRELOAD when close (even if not visible yet)
      if (entry.intersectionRatio > 0 && !video.dataset.loaded) {
        video.src = video.dataset.src;
        video.preload = "auto";
        video.load();
        video.dataset.loaded = "true";
      }

      // 🔹 PLAY only when visible
      if (entry.isIntersecting) {
        if (video.readyState >= 2) {
          video.play().catch(() => {});
        } else {
          video.addEventListener(
            "loadeddata",
            () => video.play().catch(() => {}),
            { once: true }
          );
        }
      } else {
        // Optional pause
        // video.pause();
      }
    });
  }, {
    threshold: [0, 0.25],
    rootMargin: "400px 0px" // VERY IMPORTANT
  });

  videos.forEach(video => observer.observe(video));
});
/* Video Lazy Load */

/* Footer Section */
function FooterBanner() {
  requestAnimationFrame(() => {
    const FooterMain = document.querySelector(".Footer_new");
    const FooterCustomBannerMain = document.querySelector(".Footer_mainmedia_new");

    if (!FooterMain || !FooterCustomBannerMain) return;

    const height = FooterCustomBannerMain.offsetHeight;
    FooterMain.style.marginBottom = height + "px";
  });
}

window.addEventListener("load", () => {
  FooterBanner();
  setTimeout(FooterBanner, 300);
});

window.addEventListener("resize", debounce(FooterBanner, 150));
/* Footer Section */

/* Contact Drawer */
function openContactDrawer(popupClass, noSlide) {
  // Release header drawer focus trap before opening contact drawer
  const headerDrawer = document.querySelector('header-drawer');
  if (headerDrawer && typeof headerDrawer.close === 'function') {
    headerDrawer.close();
  }

  // close any open popup first
  document.querySelectorAll('.Contact_drawer_main_new.open')
    .forEach(el => el.classList.remove('open'));

  const target = document.querySelector(`.Contact_drawer_main_new.${popupClass}`);
  if (!target) return;

  target.classList.add('open');
  document.body.classList.add('contact_drawer_is_open');

  if (noSlide) {
    document.body.classList.add('no_slide_new');
  }

  // After header drawer animation completes, force focus into contact form
  setTimeout(() => {
    const contactDrawer = document.querySelector('.Contact_drawer_main_new.open');
    if (!contactDrawer) return;

    // Re-release trap in case animation callback re-applied it
    const headerDrawer = document.querySelector('header-drawer');
    if (headerDrawer && typeof headerDrawer.close === 'function') {
      headerDrawer.close();
    }

    const firstInput = contactDrawer.querySelector(
      'input:not([type="hidden"]), textarea, select'
    );
    if (firstInput) firstInput.focus();
  }, 350);
}

document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.contact_drawer_open');
  if (!trigger) return;

  const popupClass = trigger.getAttribute('popup_id');
  if (!popupClass) return;

  openContactDrawer(popupClass, trigger.hasAttribute('no_slide'));
});

// Open the drawer from a link such as otherhalf.studio/#contact
function openContactDrawerFromHash() {
  if (window.location.hash === '#contact') openContactDrawer('contact_popup');
}
openContactDrawerFromHash();
window.addEventListener('hashchange', openContactDrawerFromHash);

document.addEventListener('click', function (e) {
  const closeTrigger = e.target.closest('.Contact_drawer_overlay_new, .contact_drawer_close');
  if (!closeTrigger) return;

  // Clear #contact so the same link can open the drawer again
  if (window.location.hash === '#contact') {
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }

  document.body.classList.remove('contact_drawer_is_open');

  // always remove no_slide_new on close
  setTimeout(() => {
    document.body.classList.remove('no_slide_new');
  }, 300);

  document.querySelectorAll('.Contact_drawer_main_new.open')
    .forEach(el => el.classList.remove('open'));
});
/* Contact Drawer */

/* Scrollbar */
document.querySelectorAll('.simplebar').forEach(el => {
  new SimpleBar(el, {
    autoHide: false
  });
});
/* Scrollbar */

/*
var Index_object_testimonial_slider = document.querySelector('.Index_object_testimonial_slider');

if (Index_object_testimonial_slider) {
    new Swiper('.Index_object_testimonial_slider', {
        loop: true,
        grabCursor: false,
        spaceBetween: 24,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        centeredSlides: true,
        observer: true,
        observeParents: true,
        freeMode: !0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        scrollbar: {
          el: ".swiper-scrollbar"
        },
        breakpoints: {
            0: {
                freeMode: !1,
                centeredSlides: false,
                spaceBetween: 16
            },
            750: {
                centeredSlides: true,
                spaceBetween: 24
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
}
*/

document.querySelectorAll('.hb-timer_count').forEach(timer => {
  const endTime = new Date(timer.dataset.timerCount).getTime();

  const daysEl = timer.querySelector('[js-days]');
  const hoursEl = timer.querySelector('[js-hours]');
  const minutesEl = timer.querySelector('[js-minutes]');

  function updateTimer() {
    const now = new Date().getTime();
    const diff = endTime - now;

    if (diff <= 0) {
      daysEl.textContent = '00';
      hoursEl.textContent = '00';
      minutesEl.textContent = '00';
      clearInterval(interval);
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);

    daysEl.textContent = String(days).padStart(2, '0');
    hoursEl.textContent = String(hours).padStart(2, '0');
    minutesEl.textContent = String(minutes).padStart(2, '0');
  }

  updateTimer();
  const interval = setInterval(updateTimer, 1000);
});

function initUpsellVariantSelection() {
  const upsellCards = document.querySelectorAll("[js-upsell-product-card]");

  upsellCards.forEach((card) => {
    const radios = card.querySelectorAll("[js-variant-value]");
    const variantInput = card.querySelector("[js-variant-input]");

    if (variantInput && radios.length > 0) {
      radios.forEach((radio) => {
        radio.addEventListener("change", () => {
          if (radio.dataset.id) {
            variantInput.value = radio.dataset.id;
          }
        });
      });
    }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  initUpsellVariantSelection();
});

document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 767) {
        new Swiper("[js-product-upsell-slider]", {
            slidesPerView: 'auto',
            spaceBetween: 16,
            freeMode: true,
            mousewheel: {
                forceToAxis: true,
            }
        });

    }

});

const drawer = document.querySelector('[js-size-chart-drawer]');

if (drawer) {
  document.querySelectorAll('[js-size-chart-trigger]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      drawer.classList.add('is-open');
      document.body.classList.add("size-chart_open")
    });
  });

  document.querySelectorAll('[js-size-chart-close]').forEach(close => {
    close.addEventListener('click', () => {
      drawer.classList.remove('is-open');
      document.setTimeout(function(){
        document.body.classList.remove("size-chart_open")
      }, 200)
    });
  });
}